export const taskActivities = ['active', 'inactive', 'all'] as const
export type TaskActivity = typeof taskActivities[number]
